module.exports = __webpack_public_path__ + "img/krisha.5819fb00.jpg";